import React from 'react';
import { Image, Text } from '@getgo/chameleon-chakra-ui';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  headingJoinFlow: {
    id: 'success.heading.join',
  },
  headingInstallFlow: {
    id: 'success.heading.install',
  },
  comment1: {
    id: 'success.covidComment',
  },
  comment2: {
    id: 'success.hashTag',
  },
});

export const SuccessIcon: React.FC = () => {
  const { formatMessage: f } = useIntl();
  return (
    <>
      <Image
        my='3.125rem'
        src={`${process.env.PUBLIC_URL}/static/media/check-mark.svg`}
        alt='GoToMeeting'
        aria-hidden='true'
      />
      <Text fontSize='18px' mb='auto' mt='1.5rem'>
        {f(messages.comment1)}
      </Text>
      <Text fontSize='18px' mt='0.625rem'>
        {f(messages.comment2)}
      </Text>
    </>
  );
};
